var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedReminderOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48905 10.4622C3.53714 8.14885 4.64079 5.50185 6.95412 4.54994L7.99263 4.1226C10.306 3.17069 12.953 4.27434 13.9049 6.58766V6.58766L13.916 6.61463C14.5566 8.17155 15.546 9.56071 16.8079 10.6751V10.6751C17.4187 11.2145 17.2518 12.2074 16.4983 12.5175L6.82018 16.4999C6.06668 16.81 5.24929 16.2221 5.30355 15.4091V15.4091C5.41566 13.7292 5.14081 12.0461 4.50015 10.4891L4.48905 10.4622V10.4622Z",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L12.6449 14.1493L12.83 14.6138C13.341 15.8965 12.7155 17.3506 11.4328 17.8616V17.8616C10.1502 18.3726 8.69612 17.7471 8.18507 16.4645L8 16Z",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L8.48697 2.59046C8.20363 1.81199 7.34287 1.41061 6.5644 1.69395V1.69395C5.78593 1.97729 5.38455 2.83805 5.66789 3.61652L6.18092 5.02606",
    stroke: "#20242E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedReminderOff);
export default __webpack_public_path__ + "static/media/ic-shared-reminder-off.001a68277283bc09fcaec5f7dea7b67c.svg";
export { ForwardRef as ReactComponent };